import { getJourneyObjectTypeId } from 'reporting-data/report/journeyReportGetters';
import { STANDARD_FIELD_TYPES } from './shared/constants/fieldTypes';
import { getJoinedTables } from 'reporting-snowflake/funnel/utils/tableUtils';
export const JourneyReportGetterStrategy = {
  [STANDARD_FIELD_TYPES.DATA_TYPE]: report => getJourneyObjectTypeId(report),
  [STANDARD_FIELD_TYPES.CHART_TYPE]: report => report.get('chartType'),
  [STANDARD_FIELD_TYPES.PRIMARY_DATA_SOURCE_ID]: report => getJourneyObjectTypeId(report),
  // Includes data sources that are joined within journey stages in addition to event objectTypeIds
  [STANDARD_FIELD_TYPES.ALL_DATA_SOURCE_IDS]: report => {
    const journey = report.toJS();
    const stages = journey.journeyQuery.stages;
    const stepDataSources = stages.flatMap(stage => {
      const steps = stage.steps;
      return steps.flatMap(step => {
        const table = step.query.table;
        const eventId = table.objectTypeId;
        const joinedTables = getJoinedTables(table);
        const joinedObjectIds = joinedTables.map(joinedTable => joinedTable.objectTypeId);
        return [eventId, ...joinedObjectIds];
      });
    });
    stepDataSources.unshift(getJourneyObjectTypeId(report));
    return [...new Set(stepDataSources)];
  }
};